import { __assign } from "tslib";
import * as React from 'react';
import { renderAndMountComponent } from '@wix/answers-lib';
import { AlertModal } from './alert-modal.comp';
import { getBaseReactDriver } from '../../common/base-driver';
// tslint:disable-next-line:max-line-length
export var createLegacyAlertModalDriver = function (elemOrLegacyBaseDriver) {
    var base = getBaseReactDriver(elemOrLegacyBaseDriver);
    return {
        getText: function () { return base.find('.body').getText(); },
        close: function () { return base.find('.close').click(); },
        base: base
    };
};
export var renderAlertModalAndReturnDriver = function (props) {
    var elem = renderAndMountComponent(React.createElement(AlertModal, __assign({}, props)));
    return createLegacyAlertModalDriver(elem);
};
//# sourceMappingURL=alert-modal.driver.js.map